import { render, staticRenderFns } from "./vendor-label-select.vue?vue&type=template&id=5ba512a0&"
import script from "./vendor-label-select.vue?vue&type=script&lang=js&"
export * from "./vendor-label-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vendor-label-select.vue"
export default component.exports